import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import fetchPendingVotesAsync from "../../redux/actions/votingFormAction";
import {
  fetchBildirimler,
  markNotificationAsRead,
  deleteNotification,
} from "../../redux/actions/bildirimActions";

const BildirimContainer = ({ setRatingIsOpen, isPopup = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pendingVotes, loading, error } = useSelector(
    (state) => state.votingForm
  );
  const { notifications } = useSelector((state) => state.bildirim);
  const [localVotes, setLocalVotes] = useState([]);

  const handleNotificationClick = async (notification) => {
    // Sadece okunmamış bildirimleri işaretle
    if (!notification.read) {
      await dispatch(markNotificationAsRead(notification._id)).unwrap();
      // Bildirimi işaretledikten sonra güncel listeyi al
      dispatch(fetchBildirimler());
    }
    console.log(notification);
    // Yönlendirme işlemleri
    switch (notification.type) {
      case "PROJECT_USER_DISCARDED":
        navigate("/projeler", {
          state: { highlightProjectId: notification.content.projectId },
        });
        break;
      case "PROJECT_USER_VOTECOMPLETED":
        navigate(`/hesabim/${notification.userId}#anketOylamasi`);
        break;
      case "PROJECT_USER_GOTFEEDBACK":
        navigate(`/hesabim/${notification.userId}#anketOylamasi`);
        break;
      case "PROJECT_USER_VOTETIME":
        setRatingIsOpen({
          isOpen: true,
          voteId: notification.content.voteId,
        });
        break;
      case "PROJECT_REJECTED":
        navigate("/projeler");
        break;
      case "PROJECT_ACCEPTED":
        navigate("/projeler", {
          state: { highlightProjectId: notification.content.projectId },
        });
        break;
      case "PROJECT_UPDATED":
        navigate("/projeler", {
          state: { highlightProjectId: notification.content.projectId },
        });
        break;
      case "PROJECT_HIRING":
        navigate("/projeler", {
          state: { highlightProjectId: notification.content.projectId },
        });
        break;
      case "PROJECT_USER_LEFT":
        navigate(`/projeler`, {
          state: { highlightProjectId: notification.content.projectId },
        });
        break;
      case "PROJECT_TO_LIVE":
        navigate("/projeler", {
          state: { highlightProjectId: notification.content.projectId },
        });
        break;
      default:
        break;
    }
  };

  const getTimeAgo = (createdAt) => {
    const now = new Date();
    const notificationDate = new Date(createdAt);
    const diffInMinutes = Math.floor((now - notificationDate) / (1000 * 60));
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInMinutes < 60) {
      return `${diffInMinutes} dk önce`;
    } else if (diffInHours < 24) {
      const remainingMinutes = diffInMinutes % 60;
      return remainingMinutes > 0
        ? `${diffInHours} saat ${remainingMinutes} dk önce`
        : `${diffInHours} saat önce`;
    } else {
      return `${diffInDays} gün önce`;
    }
  };

  useEffect(() => {
    dispatch(fetchBildirimler());
    dispatch(fetchPendingVotesAsync());
  }, [dispatch]);

  useEffect(() => {
    if (!pendingVotes?.data) {
      setLocalVotes([]);
      return;
    }
    setLocalVotes(pendingVotes.data);
  }, [pendingVotes]);

  const handleVoteClick = (voteId) => {
    setRatingIsOpen({ isOpen: true, voteId });
  };

  const handleRemoveNotification = (e, voteId) => {
    e.stopPropagation(); // Prevent triggering the parent div's click event
    setLocalVotes((prevVotes) =>
      prevVotes.filter((vote) => vote.voteId !== voteId)
    );
  };

  const getNotificationTitle = (notification) => {
    switch (notification.type) {
      case "PROJECT_USER_DISCARDED":
        return "Proje Ekibinden Çıkarıldınız!";
      case "PROJECT_USER_VOTECOMPLETED":
        return "Oylama Tamamlandı!";
      case "PROJECT_USER_GOTFEEDBACK":
        return "Yeni Bir Yorum Aldınız!";
      case "PROJECT_USER_VOTETIME":
        return `Ekip Arkadaşınız ${notification.content.targetUser} için Oylama Zamanı!`;
      case "PROJECT_REJECTED":
        return "Proje Alım Sonuçları Açıklandı!";
      case "PROJECT_ACCEPTED":
        return "Proje Alım Sonuçları Açıklandı!";
      case "PROJECT_UPDATED":
        return "Proje Aşaması Güncellendi!";
      case "PROJECT_HIRING":
        return "Kaynak Alımı Yapılacak!";
      case "PROJECT_USER_LEFT":
        return `Proje Ekibinden ${notification.content.userName} Ayrıldı!`;
      case "PROJECT_TO_LIVE":
        return "Platforma Yeni Proje Eklendi!";
      default:
        return "Bildirim";
    }
  };

  const getNotificationContent = (notification) => {
    switch (notification.type) {
      case "PROJECT_USER_DISCARDED":
        return `Artık ${notification.content.projectTitle} projesinde yer almıyorsunuz.`;
      case "PROJECT_USER_VOTECOMPLETED":
        return "Haftalık ekip oylamanız başarıyla tamamlandı ve puanlarınız güncellendi.";
      case "PROJECT_USER_GOTFEEDBACK":
        return "Ekip arkadaşlarınızdan bir yorum aldınız.";
      case "PROJECT_USER_VOTETIME":
        return "Haftalık ekip oylamanızı yapmayı unutmayın!";
      case "PROJECT_REJECTED":
        return `Üzgünüz, ${notification.content.projectTitle} projesine seçilmediniz.`;
      case "PROJECT_ACCEPTED":
        return `Tebrikler! Başvurunuz başarılı oldu ve projeye kabul edildiniz.`;
      case "PROJECT_UPDATED":
        return "Proje aşamasında bir değişiklik oldu.";
      case "PROJECT_HIRING":
        return "Projeniz için yeni kaynaklar alınacak.";
      case "PROJECT_USER_LEFT":
        return `Proje ekibinden ${notification.content.userName} ayrıldı.`;
      case "PROJECT_TO_LIVE":
        return "Kendini geliştirmek ve yeni bir yolculuğa başlamak için harika bir fırsat!";
      default:
        return null;
    }
  };

  const handleDeleteNotification = async (e, notificationId) => {
    e.stopPropagation();
    try {
      await dispatch(deleteNotification(notificationId)).unwrap();
    } catch (error) {
      console.error("Bildirim silinirken hata oluştu:", error);
    }
  };

  if (loading) return <div className="m-4 text-grayy ">Yükleniyor...</div>;
  if (error)
    return <div className="ml-4 text-grayy mb-2">Hata oluştu: {error}</div>;

  return (
    <div className="notifications-wrapper" onClick={(e) => e.stopPropagation()}>
      {notifications && notifications.length > 0 ? (
        notifications.map((notification) => (
          <div
            key={notification._id}
            className={`detay-container min-h-[152px] p-4 cursor-pointer relative my-1 ${
              !notification.read
                ? "border-l-4 border-darkerGreen bg-transparent"
                : "opacity-70"
            }`}
            onClick={() => handleNotificationClick(notification)}
          >
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <img src="/Layer2.svg" alt="logo" />
                <p
                  className={`text-dark ${
                    isPopup
                      ? "text-sm leading-[22px]"
                      : "text-base leading-[24px]"
                  } font-${!notification.read ? "semibold" : "normal"}`}
                >
                  {getNotificationTitle(notification)}
                </p>
              </div>
              <div className="flex items-center gap-2">
                {!notification.read && !isPopup && (
                  <div className="w-2 h-2 rounded-full bg-darkerGreen"></div>
                )}
                <button
                  onClick={(e) => handleDeleteNotification(e, notification._id)}
                  className="text-grayy hover:text-dark p-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div className="py-4">
              {getNotificationContent(notification) && (
                <p
                  className={`text-grayy font-normal ml-2 ${
                    isPopup
                      ? "text-sm leading-[22px]"
                      : "text-base leading-[24px]"
                  }`}
                >
                  {getNotificationContent(notification)}
                </p>
              )}
              <span className="flex justify-end font-normal text-xs text-grayy mt-2">
                {getTimeAgo(notification.createdAt)}
              </span>
            </div>
          </div>
        ))
      ) : (
        <div className="p-4 text-center text-grayy min-h-[160px] flex items-center justify-center">
          Bildirim bulunmamaktadır.
        </div>
      )}
    </div>
  );
};

export default BildirimContainer;
